/**
 * Стек перехватчиков кнопки "Назад" в Telegram.
 * 
 * Компоненты с модалками / full view могут push свой обработчик,
 * и при нажатии Telegram BackButton будет вызван последний в стеке.
 * Если стек пуст — выполняется навигация goBack() по умолчанию.
 */

const handlers = [];

/**
 * Добавить обработчик в стек (вызывать при открытии модалки)
 */
export const pushBackHandler = (handler) => {
    handlers.push(handler);
};

/**
 * Убрать обработчик из стека (вызывать при закрытии модалки)
 */
export const popBackHandler = (handler) => {
    const idx = handlers.lastIndexOf(handler);
    if (idx >= 0) handlers.splice(idx, 1);
};

/**
 * Попытаться обработать нажатие "назад" через стек перехватчиков.
 * @returns {boolean} true если обработчик нашёлся и был вызван
 */
export const handleBack = () => {
    if (handlers.length > 0) {
        const last = handlers[handlers.length - 1];
        last();
        return true;
    }
    return false;
};
